module.exports = __webpack_public_path__ + "img/img_4.8c6c68b0.jpg";